export default {
  LICENSE_APPLICATIONS: "license",
  PROFILE: "license/profile",
  LICENSE: (code) => `license${code ? "/" + code : ""}`,
  LICENSE_CERTIFICATE: (code) => `license/certificate/${code}`,
  CHECKLIST: (cat) => `license/checklist/${cat}`,
  CERTIFICATE_OF_GOOD_STANDING: (code) =>
    `license/good_standing_certificate/${code}`,
  LICENSE_UPDATE: `license/update`,
  APPLICATION: (code) => `license/application/${code}`,
  APPLICATION_REPORT: (code) => `license/application/report/${code}`,
  PROFORMA: (code) => `license/proforma/${code}`,
  UPDATE_APPLICATION: `license/update/application`,
  MEMBER_INFORMATION: (params) =>
    `license/member-information?${new URLSearchParams(params)}`,
  MEMBERSHIP_COMMENTS: (params) =>
    `license/membership-comments?${new URLSearchParams(params)}`,
};
